import { useMemo } from "react";
import { yieldMainThread } from "../utils";
/**
 * Allows to return the result of a `useMemo` as `Promise` which you could use e.g. to
 * render your UI with React's `use` method. Additionally, it yields the main thread by using `setTimeout`.
 *
 * TODO: `AbortController` to cancel the running memoization
 */ function useAsyncMemo(fn, deps) {
    return useMemo(()=>yieldMainThread().then(fn), deps);
}
export { useAsyncMemo };
